import ApiDrivenModel from "./ApiDrivenModel";
import Item from "./Item";

export default class BookmarkItem extends ApiDrivenModel {
	static ENDPOINT = "/Item_Bookmark";
	static PATHS = {
		id: true,
		account: true,
		created_on: true,
		updated_on: true,
		created_by_profile: {
			given_name: true,
			family_name: true,
			picture: true,
		},
		price: true,
		item: {
			...Item.PATHS,
			media: ["*"],
		},
	};

	/** @type Number */
	id;
	account;
	/** @type String */
	created_on;
	/** @type String */
	updated_on;
	/** @type {{given_name: string, family_name: string}} */
	created_by_profile;
	/** @type Number */
	price;
	/** @type Item */
	item;

	constructor(properties) {
		super(properties);

		// Setup children
		if (this.item) {
			this.item = new Item(this.item);
		}
	}
}
